export const home = '/';
export const opracowania = '/opracowania';
export const doPobrania = '/do-pobrania';
export const galeria = '/galeria';
